import { Component, ViewChild, ElementRef } from "@angular/core";
import { ICellRendererParams, CellValueChangedEvent, IsColumnFunc } from "ag-grid";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { IsColumnFuncParams } from "ag-grid/dist/lib/entities/colDef";


@Component({
  selector: 'ag-checkbox',
  template: `<input type="checkbox" [attr.disabled]="isEditable? null: ''" [checked]="params.value =='Y' ? 'checked' : '' " (change)="onChange($event)">`,
})
export class AgCheckboxComponent implements ICellRendererAngularComp {

  @ViewChild('.checkbox') checkbox: ElementRef;

  params: ICellRendererParams;
  isEditable: boolean;
  constructor() { }

  agInit(params: ICellRendererParams): void {
    this.params = params;
    
    if (typeof this.params.colDef.editable === 'boolean') this.isEditable = this.params.colDef.editable as boolean;
    else {
      let editableFunc: IsColumnFunc = this.params.colDef.editable as IsColumnFunc;
      this.isEditable = editableFunc(this.params);
    }
  }

  refresh() {
    return false;
  }

  onChange(event) {
    if (event.currentTarget.checked) this.params.setValue('Y');
    else this.params.setValue('N');
  }
}


// WEBPACK FOOTER //
// ./src/app/components/ag-grid/renderer/ag-checkbox.ts